export enum EMilieuPrelevementSurface {

    Ecouvillons = 1,
    BoiteContact = 2,
    Lames = 3,
    Lingettes = 4
}